export const navigation = {
  support: {
    question: "Hai bisogno di assistenza?",
    whatsappCta: "Scrivici su WhatsApp",
  },
  alt: {
    whatsapp: "Icona di WhatsApp",
    logo: "Logo della dashboard",
  },
};
